import axios, { AxiosResponse, AxiosRequestConfig } from 'axios'
const instance = axios.create();
import cookie from 'js-cookie';
import jsonp from 'jsonp';
import javaHost, { baohuoJavaHost, nodeTTSHost } from '@/bin/javaSetting';
import { Toast } from "vant";
export default abstract class AjaxConfig {
  interFaceSuccessTag: string = "S";
  interFaceErrTag: string = "E";
  interFaceStatusPropName: string = "flag";   //后台接口正常、异常状态码属性名
  interFaceErrMsgPropName: string = "res_message";   //后台接口错误提示的属性名
  loginPromise:any = null;
  httpFlag = true;
  axiosBaseUrl: string = process.env.VUE_APP_API_ROOT;
  private needLoadingRequestCount = 0;
  private loadingInstance: any;
  protected abstract clearAllCookie(): void;
  /*  protected getEnv() {
       let current: string = window.location.href;
       let currentEnv:string = '';
       if (current.indexOf('sit')>-1) {
           currentEnv = 'http://apigwroutesit.cnsuning.com/';
       } else if (current.indexOf('pre')>-1) {
           currentEnv = 'http://apigwroutepre.cnsuning.com/';
       } else {
           currentEnv = 'https://apigwroute.cnsuning.com/';
       }
       return currentEnv
   } */
  protected getCookie(name: string) {
    return cookie.get("name");
    /*let arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)");
    if(arr=document.cookie.match(reg))
        return arr[2];
    else
        return null;*/
  }

  protected getDefaultHeaderProps(): { [key: string]: any } {
    let props: { [key: string]: any } = {};
    /*从cookie，本地存储中读取缓存在本地的信息
    * {
    *     auth-id:'asifasdfasoweroiweknm',
    *     company:12
    * }
    */
    return props;
  }
  //清除所有storage中存储的数据
  protected localStorageDel() {
    // localStorage.removeItem('company');
    // localStorage.removeItem('currentUserId');
    localStorage.removeItem('rpa_token');
  }
  protected startLoading() {
    this.loadingInstance = Toast.loading({
      message: "加载中...",
      forbidClick: true,
      loadingType: 'spinner',
      overlay: true
    });
  }
  protected endLoading() {
    // vmMain.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
    Toast.clear();
    // });
  }
  protected showLoading() {
    if (this.needLoadingRequestCount === 0) {
      this.startLoading();
    }
    this.needLoadingRequestCount++;
  }
  protected hideLoading() {
    if (this.needLoadingRequestCount <= 0) return;
    this.needLoadingRequestCount--;
    if (this.needLoadingRequestCount === 0) {
      this.endLoading();
    }
  }
  login() {
    // 恶意url检测
    let sUrl = location.href;
    console.log('1. location.href = ', location.href)
    let checkURL = (/^(https?:\/\/)?[\w\-.]+\.(suning|cnsuning)\.com($|\/|\\)/i).test(sUrl) || (/^[\w][\w\/\.\-_%]+$/i).test(sUrl) || (/^[\/\\][^\/\\]/i).test(sUrl);
    sUrl = checkURL ? location.href : (location.origin + location.pathname);
    console.log('1. sUrl = ', sUrl)
  
    if (!checkURL) {
      //this.$message.warning('不合法的url，请检查');
      return;
    }
    let newLocationHref = location.origin + '/sgrp-web&loginTheme=sgrp&multipleActive=false?targetUrl=' + sUrl;
    console.log('3. newLocationHref = ', newLocationHref)
    let hrefStr;
  
   
    console.log('4. hrefStr = ', hrefStr)
  
    location.href = hrefStr;
  }
  doLogin() {
    this.login();
    return Promise.resolve();
  };
  probeAuthStatus () {
    return new Promise((resolve, reject) => {
      let sUrl = location.href;
      console.log('1. location.href = ', location.href)
      let checkURL = (/^(https?:\/\/)?[\w\-.]+\.(suning|cnsuning)\.com($|\/|\\)/i).test(sUrl) || (/^[\w][\w\/\.\-_%]+$/i).test(sUrl) || (/^[\/\\][^\/\\]/i).test(sUrl);
      sUrl = checkURL ? location.href : (location.origin + location.pathname);
      console.log('1. sUrl = ', sUrl)

      if (!checkURL) {
        //this.$message.warning('不合法的url，请检查');
        return;
      }

      jsonp(
        `${location.protocol}//${location.host}/sgrp-web/authStatus?ts=${+new Date()}`, { prefix: 'probeAuthStatus' },
        (err, { hasLogin, principal } = {}) => {
          if (err) {
            reject(err);
          }
          if (hasLogin) {
            resolve(principal);
          } else {
            reject(new Error('Not Login'));
          }
        }
      )
    });
  }
  popupLogin(request:any) {
    if (!this.loginPromise) {
      this.loginPromise = this.doLogin();
    }
    // 弹窗登录完成重发请求
    return this.loginPromise.then(() => {
      this.loginPromise = null;
      return request();
    });
  }
  /**
   * HTTP请求前置拦截
   * @param config 
   */
  beforeRequest(config: AxiosRequestConfig): AxiosRequestConfig {
    // let hideloading = config.method == 'get'?config.hideloading:config.data.hideloading
  /*   if ((config.data && !config.data.hideloading) || !config.data) {
      this.showLoading();
    } */
    // console.log(config);
    // if (config.data) {
    //   config.headers['signData'] = SHA256withECDSA(md5(JSON.stringify(config.data)).toUpperCase());
    // } else {
    //   config.headers['signData'] = SHA256withECDSA(md5(JSON.stringify({})).toUpperCase());
    // }
    // config.headers['X-Requested-With'] = 'XMLHttpRequest';
      if(config.url.indexOf('/apis')== 0){
        config.url=javaHost+config.url.split('/apis')[1]
      }
      if(config.url.indexOf('/baohuo-apis')== 0){
        config.url=baohuoJavaHost+config.url.split('/baohuo-apis')[1]
      }
    if (config.url.indexOf('/nodetts-apis') == 0) {
      config.url = nodeTTSHost + config.url.split('/nodetts-apis')[1]
    }
    if(!config.headers['Content-Type']) {
      config.headers['Content-Type'] = 'application/json';
    }
    return config;
  }

  /**
   * HTTP返回拦截器，成功状态，200
   */
  beforeResponseSuccess(res: any): any {
    // this.hideLoading();
/*     if (res.headers.sgrp_token) {
      document.cookie = `sgrp_token=${res.headers.sgrp_token};path=/;`
      localStorage.setItem('sgrp_token', res.headers.sgrp_token)
    } */
    if (res.data.message == "Required String parameter 'wwid' is not present"||res.data.message =="登录已过期,请重新登录") {
      // errTxt = message
      // if(window.location.href.indexOf("/digital-human2")!=-1){
      //    //eslint-disable-next-line
      //    window.parent.postMessage({type:'digital-human2-logout'}, '\*')
      if (this.httpFlag == false) {
        return;
      }
     
      if(location.href.indexOf('source=app')!=-1){
        let switchToLogin: any = (<any>window).switchToLogin
        switchToLogin.postMessage('')
        
      }else{
        Toast('登录已过期,请重新登录');
      // }else{
        let data={ url: '/pages/login/login?from=audioweb' }
        window.taroRawSdk.miniProgram.navigateTo(data)
      }
      this.httpFlag = false;
      // }
    }

    /* if (response.data && response.data.res_code == "005") {
      Message.error('数据已失效，请刷新页面重新请求')
    } */
    return res;
  }

  /**
   * HTTP返回拦截器，调用失败
   */
  beforeResponseError(error: any): any {
    return error;
  }

  /**
* 业务型接口返回错误
* 当接口的：【interFaceErrMsgPropName】属性值为【interFaceErrTag】的时候执行
* 如没有统一的返回错误后执行逻辑，此函数为空即可
*/
  interFaceErrReturn(err: any) {
  }

}